<template>
    <kgr-lightbox
        :value="show"
        :headline="tHeadline"
        animated
        @post-input="closeModal"
    >
        <div
            class="kgr-list-action-dialog"
        >
            <div
                v-if="entityIds.length === 0"
                class="kgr-alert kgr-alert--info kgr-row"
            >
                {{ tSelectEntitiesHint }}
            </div>

            <kgr-list-action-feedback
                v-else-if="showActionFeedback"
                :errors="listActionErrors.errors"
                :entity-ids="entityIds"
                :is-test-run="isTestRun"
                @onClose="closeModal"
                @onBackToAction="hideFeedback"
                @onExecute="executeClubAction(listActionData, false)"
            />

            <kgr-list-action-team-assignment
                v-else-if="action === 'TeamAssignment'"
                :club-id="institutionId"
                :list-id="listId"
                :entity="entity"
                :entity-ids="entityIds"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />

            <kgr-list-action-department-assignment
                v-else-if="action === 'DepartmentAssignment'"
                :club-id="institutionId"
                :list-id="listId"
                :entity-ids="entityIds"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />

            <kgr-list-action-classification-assignment
                v-else-if="action === 'ClassificationAssignment'"
                :club-id="institutionId"
                :list-id="listId"
                :entity-ids="entityIds"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />

            <kgr-list-action-send-letter-draft
                v-else-if="isActionSendLetterDraft"
                :club-id="institutionId"
                :list-id="listId"
                :entity-ids="entityIds"
                :entity="entity"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />
            <kgr-list-action-club-fee-assignment
                v-else-if="isActionClubFeeAssignment"
                :club-id="institutionId"
                :list-id="listId"
                :entity-ids="entityIds"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />
            <kgr-list-action-create-dog-letter-draft
                v-else-if="action === 'CreateLetterDraft'"
                :club-id="institutionId"
                :list-id="listId"
                :entity-ids="entityIds"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />

            <kgr-list-action-end-member-club-fees
                v-else-if="action === 'EndMemberClubFees'"
                :entity-ids="entityIds"
                :loading="loading"
                :saved-action-data="listActionData"
                @onClose="closeModal"
                @executeAction="executeClubAction"
            />

            <div
                v-else
                class="kgr-alert kgr-alert--info kgr-row"
            >
                Action not yet implemented
            </div>
        </div>

        <kgr-confirm
            ref="confirmExecute"
            :headline="tConfirmationHeadline"
        >
            <div>
                {{ tConfirmation }}
            </div>

            <div
                v-if="tExtraConfirmationHint !== ''"
            >
                {{ tExtraConfirmationHint }}
            </div>
        </kgr-confirm>
    </kgr-lightbox>
</template>

<script>
import BatchClubFeeAssignment from './actions/club-member/clubfee-assignment/BatchClubFeeAssignment.js';
import BatchProcessingRepository from './ListBatchProcessingRepository.js';
import BatchSendLetterDraft from './actions/common/send-letter-draft/BatchSendLetterDraft.js';
import ClassificationAssignment from './actions/club-member/classification-assignment/ClassificationAssignment.vue';
import ClubFeeAssignment from './actions/club-member/clubfee-assignment/ClubFeeAssignment.vue';
import ConfirmDialog from '../../common/modal/ConfirmDialog.vue';
import CreateDogLetterDraft from './actions/club-dog/create-letter-draft/CreateLetterDraft.vue';
import DepartmentAssignment from './actions/club-member/department-assignment/DepartmentAssignment.vue';
import EndMemberClubFees from './actions/member-club-fee/end-member-club-fees/EndMemberClubFees.vue';
import Lightbox from '../../common/modal/Lightbox.vue';
import ListActionFeedback from './ListActionFeedback.vue';
import SendLetterDraft from './actions/common/send-letter-draft/SendLetterDraft.vue';
import TeamAssignment from './actions/club-member/team-assignment/TeamAssignment.vue';

export default {
    components: {
        'kgr-confirm': ConfirmDialog,
        'kgr-lightbox': Lightbox,
        'kgr-list-action-feedback': ListActionFeedback,
        'kgr-list-action-team-assignment': TeamAssignment,
        'kgr-list-action-department-assignment': DepartmentAssignment,
        'kgr-list-action-classification-assignment': ClassificationAssignment,
        'kgr-list-action-send-letter-draft': SendLetterDraft,
        'kgr-list-action-club-fee-assignment': ClubFeeAssignment,
        'kgr-list-action-create-dog-letter-draft': CreateDogLetterDraft,
        'kgr-list-action-end-member-club-fees': EndMemberClubFees,
    },
    props: {
        action: {
            type: String,
            required: true,
        },
        entity: {
            type: String,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        institutionId: {
            type: Number,
            required: true,
        },
        listId: {
            type: Number,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            listActionErrors: null,
            isTestRun: false,
            showActionFeedback: false,
            loading: false,
            listActionData: null,
        };
    },
    computed: {
        tHeadline() {
            if (this.action === '') {
                return '';
            }
            return this.$t(`Lists.actions.headline.${this.action}`);
        },
        tExtraConfirmationHint() {
            if (this.isActionClubFeeAssignment) {
                return this.$t('Lists.actions.ClubFeeAssignment.extraHint');
            }
            return '';
        },
        tSelectEntitiesHint() {
            return this.$t('Lists.actions.noEntitiesSelected');
        },
        tConfirmation() {
            if (this.listActionErrors) {
                return this.$t('Lists.actions.confirmation', { count: this.entityIds.length - this.listActionErrors.errorCount });
            }
            return this.$t('Lists.actions.confirmation', { count: this.entityIds.length });
        },
        tConfirmationHeadline() {
            return this.$t('Lists.actions.confirmationHeadline');
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        isActionSendLetterDraft() {
            return this.action === BatchSendLetterDraft.ACTION_NAME;
        },
        isActionClubFeeAssignment() {
            return this.action === BatchClubFeeAssignment.ACTION_NAME;
        },
    },
    methods: {
        closeModal() {
            this.listActionData = null;
            this.listActionErrors = null;
            this.showActionFeedback = false;
            this.$emit('onClose');
        },
        showFeedback() {
            this.showActionFeedback = true;
        },
        hideFeedback() {
            this.showActionFeedback = false;
        },
        async executeClubAction(data, isTestRun) {
            this.listActionData = data;
            let confirmed = false;
            this.isTestRun = isTestRun;
            if (!isTestRun) {
                confirmed = await this.$refs.confirmExecute.open();
            }
            if (confirmed || isTestRun === true) {
                this.loading = true;
                BatchProcessingRepository.executeClubBatchAction(this.listId, data.serialize(), isTestRun)
                    .then((listActionErrors) => {
                        this.loading = false;
                        this.listActionErrors = listActionErrors;
                        if (!isTestRun && listActionErrors.errorCount === 0) {
                            this.$notify.success('Lists.actions.success');
                            this.hideFeedback();
                        }
                        if (isTestRun || listActionErrors.errorCount > 0) {
                            this.showFeedback();
                        } else {
                            this.closeModal();
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$notify.error('Lists.actions.error');
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.kgr-list-action-dialog {
    overflow-y: auto;
    max-height: 750px;
    padding: 2px;
}
</style>
